import { render, staticRenderFns } from "./DirectionView.vue?vue&type=template&id=7471675f&scoped=true&"
import script from "./DirectionView.vue?vue&type=script&lang=js&"
export * from "./DirectionView.vue?vue&type=script&lang=js&"
import style0 from "./DirectionView.vue?vue&type=style&index=0&id=7471675f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7471675f",
  null
  
)

export default component.exports